
////////////////////////////////////
// M039 pop up

function initPopup() {

    $(".popupLayer").each(function () {
        $(this).find(".popupLayerCloseButton").click(function () {
            $(this).closest(".popupLayer").hide();
        });
        $(this).find(".popupLayerCloseButton").on("keydown", handleKeyDownForClick);

        $(this).find(".popupLayerBackground").click(function () {
            $(this).closest(".popupLayer").hide();
        });
        $(this).find(".popupLayerBackground").on("keydown", handleKeyDownForClick);
    });

    $(".popupButton").click(function (e) {
        e.preventDefault();
        
        if ($(this)[0].hasAttribute("data-popup-id")) {
            var id = $(this).attr("data-popup-id");
            $("#" + id).show();
            
            if ($(this)[0].hasAttribute("href")) {
                var url = $(this).attr("href");
                $("#" + id).find(".popupLayerLinkButton").attr("href", url);
            }
            if ($(this)[0].hasAttribute("target")) {
                var target = $(this).attr("target");
                $("#" + id).find(".popupLayerLinkButton").attr("target", target);
            }
        }
    });
    $(".popupButton").on("keydown", handleKeyDownForClick);
    
}